module.exports = require('../dist/components/Input/Input');
